<template>
    <header>
        <div class="flex flex-col">
            <div class="flex max-lg:items-center max-lg:justify-between max-lg:px-3.75">
                <BurgerMenu></BurgerMenu>
                <div>
                    <router-link :to="{ name: 'medias' }">
                        <AppLogo/>

                    </router-link>
                </div>
                <div class="ml-auto flex items-center gap-10 max-lg:hidden">
                    
                    <router-link v-if="HABARLAR_ENABLED" :to="{ name: 'news' }" class="relative text-black font-bold text-lg">
                        {{ $t('nav.news') }}
                        <span class="absolute -top-1 -right-4 text-center text-sm  rounded-full bg-red-500 text-white font-normal aspect-square w-5 h-5" v-if="getLastSeenAnnouncementsCount">{{ getLastSeenAnnouncementsCount }}</span>
                    </router-link>
                    <router-link :to="{ name: 'medias' }" class="relative text-black font-bold text-lg">
                        {{ $t('nav.media') }}
                        <span class="absolute -top-1 -right-4 text-center text-sm  rounded-full bg-red-500 text-white font-normal aspect-square w-5 h-5" v-if="getLastSeenVideosCount">{{ getLastSeenVideosCount }}</span>
                    </router-link>
                    <router-link :to="{ name: 'mediaLiked' }" class="relative text-black font-bold text-lg">
                        {{ $t('nav.liked') }}
                        <span class="absolute -top-1 -right-4 text-center text-sm  rounded-full bg-red-500 text-white font-normal aspect-square w-5 h-5" v-if="mediaLikedBadgeCount > 0">{{ mediaLikedBadgeCount }}</span>
                    </router-link>
                    <router-link :to="{ name: 'businessAccounts' }" class="relative text-black font-bold text-lg">
                        {{ $t('nav.businessAccounts') }}
                        <span class="absolute -top-1 -right-4 text-center text-sm  rounded-full bg-red-500 text-white font-normal aspect-square w-5 h-5" v-if="getLastSeenBusinessAccountsCount">{{ getLastSeenBusinessAccountsCount }}</span>

                    </router-link>
                    <div class="flex ">
                        <LocationButton></LocationButton>
                        <div class="ml-4">
                            <ProfileButton ></ProfileButton>
                        </div>
                    </div>
                </div>
                <div class="hidden max-lg:flex">
                    <LocationButton customClass="mr-4 bg-[#f9f9f9] shadow-sm"></LocationButton>
                    <LanguageSwitcher extraclasswrapper="border-black" extraclasslabel="!text-black"></LanguageSwitcher>
                </div>
            </div>
            <div class="hidden max-lg:flex max-lg:mt-5 bg-white">
                <MiddleNav></MiddleNav>
            </div>
            <div class="mt-5">
                <SearchBar v-if="HABARLAR_ENABLED" section="news" :placeholder="$t('page.searchNewsByName')"></SearchBar>
            </div>
        </div>
    </header>
</template>

<script>
import LanguageSwitcher from '@cmp/LanguageSwitcher.vue'
import AppLogo from '@cmp/AppLogo.vue'
import MiddleNav from '@cmp/MiddleNav.vue'
import ProfileButton from '@cmp/ProfileButton.vue'
import SearchBar from '@cmp/SearchBar.vue'
import CategoriesDropdown from '@cmp/publication/CategoriesDropdown.vue'
import LocationButton from '@cmp/LocationButton.vue'
import BurgerMenu from '@cmp/BurgerMenu.vue'
import { mapState } from 'pinia'
import { useAppStore } from '@/store'
import { FEATURE_FLAGS } from '@/constants'
export default {
    name: 'MediaHeader',
    components: {
        AppLogo,
        CategoriesDropdown,
        ProfileButton,
        LocationButton,
        SearchBar,
        BurgerMenu,
        LanguageSwitcher,
        MiddleNav
    },
    data(){
        return {
            loading: false,
            HABARLAR_ENABLED: FEATURE_FLAGS.HABARLAR
        }
    },
    methods: {

    },
    computed: {
        ...mapState(useAppStore, ['getMediaNewsLikedCount', 'getMediaLikedCount', 'getLastSeenVideosCount', 'getLastSeenAnnouncementsCount', 'getLastSeenBusinessAccountsCount']),
        mediaLikedBadgeCount(){
            return this.HABARLAR_ENABLED ? this.getMediaNewsLikedCount : this.getMediaLikedCount
        },
        mediaCategories(){
            return this.$store.mediaCategories
        },

    },
    created(){

    }
}
</script>
<style scoped>
.router-link-exact-active{
    color: #409DBA;
}
</style>